export default __webpack_public_path__ + "2e4745ad991b8f5f0b83b549a629a0ff.png";